/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalView/Content/Address/Addresses/Content/Address"
  
}) {
let addressPostalAddressValueData = fromData.useDataFormat({ viewPath,
context: 'address',
path: 'postal_address',
format: fromFormat.format_address,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="block"
 marginBottom={dtSpaceXxs}
 width="100%"
 justifyContent="space-between"
 data="address.postal_address"
 format="/Data/format.js format_address"
 text={addressPostalAddressValueData}
/>
{children}
</React.Fragment>)
}